var React = require('react');

function Api (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 16A8 8 0 108 0a8 8 0 000 16zM5.133 9.445h-1.71l-.345 1.117H1.78l1.74-4.95h1.545l1.732 4.95H5.47l-.337-1.117zm-.27-.877l-.36-1.185-.218-.78H4.27l-.202.772-.375 1.193h1.17zm4.783-2.955c.615 0 1.087.142 1.417.427.33.28.495.685.495 1.215 0 .505-.165.897-.495 1.177-.33.275-.802.413-1.417.413h-.983v1.717h-1.29v-4.95h2.273zM9.443 7.9c.28 0 .485-.053.615-.158.135-.11.203-.277.203-.502 0-.22-.068-.383-.203-.487-.13-.11-.335-.165-.615-.165h-.78V7.9h.78zm2.94 2.662h1.29v-4.95h-1.29v4.95z"}));
}

Api.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Api;

Api.default = Api;
